// 261005 test-dev F2/F5/F6 — chữ + chuẩn hoá cho khối "Nạp truyện" ở ① Nguồn. KHÔNG import antd (jest của react-scripts không load được antd v6).
import type { ProbeReport } from '../../types/adaptation';

/** BE chặn trần 1000 chương/lần nạp (`maxChapters`). */
export const MAX_CRAWL_CHAPTERS = 1000;

/** Giá trị ô "Số chương" → `maxChapters` gửi BE. Trống/không hợp lệ ⇒ undefined (= nạp tất cả); số thập phân bị cắt; vượt trần ⇒ trần. */
export const normalizeMaxChapters = (v: unknown): number | undefined => {
  const n = typeof v === 'string' ? (v.trim() === '' ? NaN : Number(v)) : typeof v === 'number' ? v : NaN;
  if (!Number.isFinite(n)) return undefined;
  const i = Math.floor(n);
  if (i < 1) return undefined;
  return Math.min(i, MAX_CRAWL_CHAPTERS);
};

type ProbeTotal = Pick<ProbeReport, 'totalChapters' | 'tocSource'>;

const knownTotal = (p: ProbeTotal | null | undefined): number | null =>
  p && typeof p.totalChapters === 'number' && Number.isFinite(p.totalChapters) && p.totalChapters > 0 && p.tocSource !== 'NONE' ? p.totalChapters : null;

/** F6: "121 chương" (mục lục đủ) · "Khoảng ≥ 64 chương" (đoán từ chương, chỉ là cận dưới) · null (không biết). */
export const probeTotalText = (p: ProbeTotal | null | undefined): string | null => {
  const n = knownTotal(p);
  if (n === null) return null;
  return p!.tocSource === 'TOC' ? `${n} chương` : `Khoảng ≥ ${n} chương`;
};

/** Gợi ý trong ô "Số chương" (để trống = nạp tất cả). */
export const crawlCountPlaceholder = (p: ProbeTotal | null | undefined): string => {
  const n = knownTotal(p);
  if (n === null) return 'Tất cả';
  return p!.tocSource === 'TOC' ? `Tất cả (${n})` : `Tất cả (≥ ${n})`;
};

/** Tiêu đề Popconfirm "Nạp và tự quét" — nêu số chương khi người dùng đã chọn. Không có số tiền. */
export const crawlConfirmTitle = (maxChapters: number | undefined): string =>
  `${maxChapters ? `Nạp ${maxChapters} chương đầu và tự quét` : 'Nạp và tự quét'} — giá quét tính theo số chương thực tế lấy về`;

/** F37: chương đầu chưa có là sau chỉ số lớn nhất hiện có; không suy từ `length` vì danh sách có thể hở số. */
export interface CrawlChapterOrder { orderIndex: number }

export const firstAdditionalChapter = (chapters: ReadonlyArray<CrawlChapterOrder>): number =>
  Math.max(0, ...chapters.map((c) => Number.isInteger(c.orderIndex) ? c.orderIndex : 0)) + 1;

/** Tham số nạp thêm giữ riêng để UI không vô tình gọi lại từ chương 1. */
export const additionalCrawlParams = (
  chapters: ReadonlyArray<CrawlChapterOrder>,
  maxChapters: number | undefined,
  autoScan = true,
): { startChapter: number; maxChapters: number | undefined; autoScan: boolean } => ({ startChapter: firstAdditionalChapter(chapters), maxChapters, autoScan });

/** Chữ xác nhận phải nói rõ đây chỉ là phần mới, không chạm chương hiện có. */
export const additionalCrawlConfirmTitle = (startChapter: number, maxChapters: number | undefined): string =>
  `Nạp ${maxChapters ?? 'tất cả'} chương mới, không đụng chương đã có — từ chương ${startChapter}`;

/** F2: điền sẵn link của truyện vào ô khi ô còn trống; đã gõ thì giữ nguyên. */
export const prefillUrl = (current: string, storyLink: string | null | undefined): string => {
  if (current.trim()) return current;
  return (storyLink ?? '').trim();
};
